import { render, staticRenderFns } from "./AccountReactivateEmail.vue?vue&type=template&id=0992700a&scoped=true"
import script from "./AccountReactivateEmail.vue?vue&type=script&lang=ts"
export * from "./AccountReactivateEmail.vue?vue&type=script&lang=ts"
import style0 from "./AccountReactivateEmail.vue?vue&type=style&index=0&id=0992700a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0992700a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0992700a')) {
      api.createRecord('0992700a', component.options)
    } else {
      api.reload('0992700a', component.options)
    }
    module.hot.accept("./AccountReactivateEmail.vue?vue&type=template&id=0992700a&scoped=true", function () {
      api.rerender('0992700a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/AccountReactivateEmail.vue"
export default component.exports